import React from "react";

const FeaturesCard = ({ icon, title, description }) => {
  return (
    <>
      {/* <div className="py-[50px] px-[30px] flex flex-col gap-[10px] items-center text-center max-w-sm mx-auto relative w-full h-full drop-shadow-lg backdrop-blur-lg">
        <img
          src="../../assets/images/home/featureCardbg.png"
          alt="users"
          className="max-w-[419px] w-full max-xxl:max-h-[298px]  max-h-[228px] h-full absolute z-[-1] top-0"
        />
        <div className="absolute top-[-24%]">
          <img src={icon} alt="" color="#00BBDD" width={63} height={63} />
        </div>
        <h6 className="font-bold font-manrope leading-[35px] text-blue ">
          {title}
        </h6>
        <h6 className="font-normal font-manrope txt-color tracking-[-0.8px]">
          {description}
        </h6>
      </div> */}
      <div class="_super-box">
        <div class="_container">
          <div class="_box">
            <div class="_icon_bg"></div>
            <p className="icon-inner text-center large  font-normal font-manrope txt-color tracking-[-0.8px]">
              {/* {description}
               */}
              <ul className="list-disc list-inside mt-[20px] px-[10px]">
                {description.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </p>
          </div>
          <div class="_icon flex flex-col items-center">
            <img src={icon} alt="" color="#00BBDD" width={63} height={63} />

            <div class="_text mt-[230px]">
              <h6 className="font-bold capitalize font-manrope leading-[35px] text-blue mt-[60px]">
                {title}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeaturesCard;
